import { render } from "./TrxPress.vue?vue&type=template&id=29e27f86&scoped=true"
import script from "./TrxPress.vue?vue&type=script&lang=js"
export * from "./TrxPress.vue?vue&type=script&lang=js"

import "./TrxPress.vue?vue&type=style&index=0&id=29e27f86&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e27f86"]])

export default __exports__